module.exports = __webpack_public_path__ + "media/newstyle/images/icon-play-two-ed3ec600e98d78742380052e9cd13a6b.svg";